// @flow

export { OneClickCard } from './types';
export { getOneClickCard, getOneClickCardOrCry } from './get-one-click-card';
